import { Component } from "@angular/core";

@Component({
	selector: "no-results-found",
	templateUrl: "./no-results-found.component.html",
	styleUrls: ["./no-results-found.component.scss"],
	standalone: false
})
export class NoResultsFoundComponent {}
